import { render, staticRenderFns } from "./UsuarioLista.vue?vue&type=template&id=54ec376e&scoped=true&"
import script from "./UsuarioLista.vue?vue&type=script&lang=js&"
export * from "./UsuarioLista.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioLista.vue?vue&type=style&index=0&id=54ec376e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec376e",
  null
  
)

export default component.exports